













































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AjukanAksesRevisiDialog from "@/components/pemeriksaan/AjukanAksesRevisiDialog.vue";
import BerkasFormPanel from "@/components/pemeriksaan/berkasRm/BerkasFormPanel.vue";
import { storePersetujuanIntensif } from "@/store/modules/PersetujuanIntensifStore";
import PersetujuanIntensifSvc from "@/services/PersetujuanIntensif";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { diagnoseAccess, unitKategoriLabel } from "@/utils/form-access";
import { formRoleOwners } from "@/utils/role-marker";
import { getHumanDateTime, formatDMYDate } from "@/utility/DateUtils";

@Component({
  components: {
    AjukanAksesRevisiDialog,
    BerkasFormPanel
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanIntensif extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isEditing = false;
  deleting = false;
  saving = false;
  finalizing = false;
  formValid = false;

  hubunganOptions = [
    "Diri sendiri",
    "Suami",
    "Istri",
    "Anak",
    "Ayah",
    "Ibu",
    "Saudara kandung",
    "Lainnya"
  ];

  persetujuanUntukOptions = [
    "Diri saya sendiri",
    "Suami",
    "Istri",
    "Anak",
    "Ayah",
    "Ibu",
    "Saudara kandung",
    "Lainnya"
  ];

  pembiayaanOptions = [
    "Umum (biaya sendiri)",
    "Jamkesda / Jamkesos",
    "BPJS PBI (Jamkesmas)",
    "BPJS Non PBI ( Askes Sosial / Jamsostek / ASABRI )",
    "Asuransi lainnya"
  ];

  unitIntensifOptions = ["ICU", "NICU", "HCU", "PICU"];

  form: any = this.getEmptyForm();

  async mounted() {
    await storePersetujuanIntensif.getByRegister(this.register);

    // `getEmptyForm()` dievaluasi saat field diinisialisasi — getter komponen
    // belum tentu siap di titik itu, jadi prefill diulang setelah mount.
    if (!this.statePersetujuan && !this.form.petugas_ruang_nama) {
      this.form.petugas_ruang_nama = this.namaUserLogin;
    }
  }

  getEmptyForm() {
    return {
      pj_nama: "",
      pj_jenis_kelamin: "",
      pj_tgl_lahir: "",
      pj_no_identitas: "",
      pj_no_hp: "",
      pj_alamat: "",
      pj_hubungan: "",
      pj_hubungan_lainnya: "",
      jenis_pembiayaan: "",
      pembiayaan_keterangan: "",
      unit_intensif: "",
      persetujuan_untuk_hubungan: "",
      persetujuan_untuk_lainnya: "",
      petugas_ruang_nama: this.namaUserLogin,
      catatan: "",
      tempat_tanda_tangan: "Bantul"
    };
  }

  get namaUserLogin(): string {
    const u = this.stateuser as any;
    return (u && (u.nama || u.name)) || "";
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  get stateuser() {
    return userModule.user;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get statePersetujuan() {
    return storePersetujuanIntensif.persetujuan;
  }

  get canMakePersetujuan() {
    if (this.cardReadOnly) return false;
    return userModule.canAccessForm("persetujuan_rawat_intensif", "create");
  }

  get isFinalized(): boolean {
    return !!(this.statePersetujuan && this.statePersetujuan.is_finalized);
  }

  get adaBerkas(): boolean {
    return !!(this.statePersetujuan && this.statePersetujuan.berkas_count > 0);
  }

  get unlockedByRevision(): boolean {
    const c = this.statePersetujuan;
    return !!(c && !c.is_finalized && c.revision_request_id);
  }

  get cardReadOnly(): boolean {
    return this.readOnly && !this.unlockedByRevision;
  }

  get canEditState() {
    if (this.cardReadOnly) return false;
    if (!this.statePersetujuan) return false;
    return !this.isFinalized;
  }

  get canFinalisasiSlot(): boolean {
    return !!this.statePersetujuan && !this.isFinalized && !this.cardReadOnly;
  }

  get isDokter() {
    return !!(this.stateuser && this.stateuser.profesi === "Dokter");
  }

  get alasanFinalisasi(): string {
    if (!this.isDokter) {
      return "Hanya dokter yang dapat memverifikasi & memfinalisasi dokumen ini.";
    }
    if (!this.adaBerkas) {
      return "Unggah scan lembar bertanda tangan basah dulu sebelum finalisasi.";
    }
    return "Verifikasi dokter sekaligus mengunci dokumen.";
  }

  get statusLabel(): string {
    if (this.isFinalized) return "Final";
    if (this.unlockedByRevision) return "Dibuka untuk revisi";
    return "Draft";
  }

  get statusColor(): string {
    if (this.isFinalized) return "green";
    if (this.unlockedByRevision) return "amber darken-2";
    return "orange";
  }

  get labelDokumen(): string {
    const unit =
      this.statePersetujuan && this.statePersetujuan.unit_intensif
        ? ` — ${this.statePersetujuan.unit_intensif}`
        : "";
    return `Persetujuan Rawat Intensif${unit}`;
  }

  /** `rm` di Ralan/IGD berisi cm 8 digit; berkas_rm_pasien menyimpan 6 digit. */
  get rmKey(): string {
    const rm = String(this.rm || "");
    return rm.length > 6 ? rm.slice(-6) : rm;
  }

  get alasanTidakBisaBuat() {
    if (this.cardReadOnly) {
      return "Berkas sudah melewati batas waktu penyuntingan, persetujuan tidak dapat dibuat.";
    }

    const u = userModule.user;
    const d = diagnoseAccess(
      u && u.unit_id,
      u && u.profesi,
      u && u.role && u.role.id,
      "persetujuan_rawat_intensif",
      "create"
    );

    if (d.reason === "unit_mismatch") {
      const units = d.allowedUnitKategoriForProfesi
        .map(unitKategoriLabel)
        .join(", ");
      return `Anda belum bisa membuat persetujuan dari unit ini. Khusus unit: ${units}.`;
    }

    const owners = formRoleOwners("persetujuan_rawat_intensif")
      .map(o => o.label)
      .join(", ");

    return owners
      ? `Anda belum bisa membuat persetujuan. Pengisian dilakukan oleh: ${owners}.`
      : "Anda belum bisa membuat persetujuan dari akun ini.";
  }

  get showPembiayaanKeterangan() {
    return this.form.jenis_pembiayaan === "Asuransi lainnya";
  }

  onHubunganChange(val: string) {
    if (val === "Diri sendiri" && this.statePasien) {
      this.form.pj_nama = this.statePasien.nama || "";
      this.form.pj_tgl_lahir = this.statePasien.tgl_lahir
        ? formatDMYDate(this.statePasien.tgl_lahir)
        : "";
      this.form.pj_jenis_kelamin = this.statePasien.jk === "Laki-laki" ? "L" : "P";
      this.form.pj_alamat = this.statePasien.alamat || "";
    } else if (val !== "Diri sendiri") {
      // Reset fields when switching away from "Diri sendiri"
      if (this.form.pj_hubungan !== val) {
        this.form.pj_nama = "";
        this.form.pj_tgl_lahir = "";
        this.form.pj_jenis_kelamin = "";
        this.form.pj_alamat = "";
      }
    }
    if (val !== "Lainnya") {
      this.form.pj_hubungan_lainnya = "";
    }
  }

  startEdit() {
    const c = this.statePersetujuan;
    this.form = {
      pj_nama: c.pj_nama || "",
      pj_jenis_kelamin: c.pj_jenis_kelamin || "",
      pj_tgl_lahir: c.pj_tgl_lahir || "",
      pj_no_identitas: c.pj_no_identitas || "",
      pj_no_hp: c.pj_no_hp || "",
      pj_alamat: c.pj_alamat || "",
      pj_hubungan: c.pj_hubungan || "",
      pj_hubungan_lainnya: c.pj_hubungan_lainnya || "",
      jenis_pembiayaan: c.jenis_pembiayaan || "",
      pembiayaan_keterangan: c.pembiayaan_keterangan || "",
      unit_intensif: c.unit_intensif || "",
      persetujuan_untuk_hubungan: c.persetujuan_untuk_hubungan || "",
      persetujuan_untuk_lainnya: c.persetujuan_untuk_lainnya || "",
      petugas_ruang_nama: c.petugas_ruang_nama || "",
      catatan: c.catatan || "",
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul"
    };
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    if (!(this.$refs.formPersetujuan as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        pj_hubungan_lainnya: this.form.pj_hubungan === "Lainnya"
          ? this.form.pj_hubungan_lainnya
          : null,
        pembiayaan_keterangan: this.showPembiayaanKeterangan
          ? this.form.pembiayaan_keterangan
          : null,
        persetujuan_untuk_lainnya: this.form.persetujuan_untuk_hubungan === "Lainnya"
          ? this.form.persetujuan_untuk_lainnya
          : null
      };

      let resp;
      if (this.statePersetujuan && this.isEditing) {
        resp = await PersetujuanIntensifSvc.update(this.statePersetujuan.id, payload);
      } else {
        resp = await PersetujuanIntensifSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Rawat Intensif berhasil disimpan");
        this.isEditing = false;
        this.form = this.getEmptyForm();
        this.reload();
      }
    } finally {
      this.saving = false;
    }
  }

  reload() {
    storePersetujuanIntensif.getByRegister(this.register);
  }

  async finalisasi() {
    if (!this.statePersetujuan || this.finalizing) return;

    const q = confirm(
      "Verifikasi & finalisasi Persetujuan Rawat Intensif? Setelah difinalisasi dokumen terkunci dan hanya dapat diubah lewat pengajuan revisi."
    );
    if (!q) return;

    this.finalizing = true;

    try {
      const resp = await PersetujuanIntensifSvc.finalize(this.statePersetujuan.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay(
          resp.data.message || "Persetujuan Rawat Intensif diverifikasi dan terkunci"
        );
        this.reload();
      }
    } finally {
      this.finalizing = false;
    }
  }

  openUpload() {
    const panel = this.$refs.berkasPanel as any;
    if (panel && panel.openUpload) panel.openUpload();
  }

  onBerkasChanged() {
    this.reload();
  }

  cetakPdf() {
    PersetujuanIntensifSvc.print(this.statePersetujuan.id);
  }

  async remove() {
    const q = confirm("Anda yakin akan menghapus Persetujuan Rawat Intensif ini?");

    if (q && !this.deleting) {
      this.deleting = true;

      try {
        const resp = await PersetujuanIntensifSvc.destroy(this.statePersetujuan.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          this.reload();
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
